import { APIResponse } from "@thenounproject/lingo-core";
import { UnknownAction } from "redux";

export const getEntities = (action: UnknownAction): APIResponse["entities"] => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const act = action as any;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return act?.response?.entities || act?.payload?.entities;
};
